import PropTypes from 'prop-types';
import { Checkbox } from 'src/features/tyre-management/components/ui/checkbox';

const ModulesSection = ({ checked, onCheckedChange, globalEnabled, enabledAt }) => {
  if (!globalEnabled) return null;

  const sinceLabel = checked && enabledAt
    ? new Intl.DateTimeFormat('en-IN', { dateStyle: 'medium' }).format(new Date(enabledAt))
    : null;

  return (
  <section id="edit-modules" className="vd-edit-section vd-section-anchor">
    <div>
      <p className="vd-eyebrow">Tyre tracking</p>
      <h2>Track this vehicle&apos;s tyres</h2>
      <p className="vd-edit-help">Turn this on to choose its wheel layout and record which tyre is fitted at each position.</p>
    </div>
    <div className="vd-form-grid">
      <label className="vd-switch-row" htmlFor="tyre-management-enabled">
        <Checkbox
          id="tyre-management-enabled"
          checked={Boolean(checked)}
          onCheckedChange={(value) => onCheckedChange(value === true)}
          aria-describedby="tyre-management-enabled-help"
        />
        <span>
          <strong>Track tyres for this vehicle</strong>
          <small id="tyre-management-enabled-help">
            After saving, choose the vehicle&apos;s wheel layout in Tyre Management, then assign its tyres.
            {sinceLabel ? ` Enabled since ${sinceLabel}.` : ''}
          </small>
        </span>
      </label>
    </div>
  </section>
  );
};

ModulesSection.propTypes = {
  checked: PropTypes.bool,
  onCheckedChange: PropTypes.func.isRequired,
  globalEnabled: PropTypes.bool,
  enabledAt: PropTypes.string,
};

ModulesSection.defaultProps = {
  checked: false,
  globalEnabled: false,
  enabledAt: null,
};

export default ModulesSection;
